module.exports = __webpack_public_path__ + "media/src/assets/Images/LogoutIcon-a21a3d8e00941e5f202a7d75b8ab404e.svg";